import React from 'react';

export interface BreadcrumbCurrentLocationProps {
    name: string;
}

export default function BreadcrumbsCurrentLocation(props: BreadcrumbCurrentLocationProps) {
    const {name} = props;
    
    return (
        <span
            className="breadcrumbs__current"
        >
            {name}
        </span>
    );
}
